var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassWithEggInVinegar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 90,
    viewBox: "0 0 63 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671575 3 1.5 3H1.60938C1.8047 3 2 4 2 4V86C2 88.2091 3.79086 90 6 90H57C59.2091 90 61 88.2091 61 86V4C61 4 61.1953 3 61.3906 3H61.5C62.3284 3 63 2.32843 63 1.5C63 0.671573 62.3284 0 61.5 0H61H2H1.5Z",
    fill: "#CDE2ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 25,
    height: 2,
    rx: 1,
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14267 45L54.8695 44.9631C57.148 44.9631 59 43.0959 59 40.7988V19.5803C39.3954 18.8923 29.0321 16 4 16L4 40.8233C4 43.1328 5.85202 45 8.14267 45Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.2V83.7989C4 86.1287 5.85038 88.0123 8.139 87.9999L54.8245 87.9628C57.1009 87.9628 59 85.9974 59 83.68V16.44C59 16.0187 58.9757 15.4213 59 15C39.7902 15.1859 30.7949 22.2 4 22.2Z",
    fill: "#66CEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8052 45C41.384 44.9765 48.0591 62.2931 45.4245 73.2685C43.0937 82.9871 36.3985 85 31.039 85C25.6795 85 19.1713 82.3855 16.6535 73.6449C13.7417 63.5231 20.9344 45.0235 30.8052 45Z",
    fill: "#F2A05B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7342 53.2401C21.4653 55.28 20.1864 57.8474 19.9126 59.988C19.4117 63.9299 22.2935 64.3735 23.2986 62.4177C24.3037 60.4619 25.3322 58.4825 26.9651 55.858C29.2224 52.232 32.9189 49.8024 31.1024 48.2263C29.2858 46.6502 25.399 48.9522 22.7342 53.2401Z",
    fill: "#FECC88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1451 58.8218C40.5176 58.8218 40.8196 58.5119 40.8196 58.1296C40.8196 57.7473 40.5176 57.4373 40.1451 57.4373C39.7726 57.4373 39.4706 57.7473 39.4706 58.1296C39.4706 58.5119 39.7726 58.8218 40.1451 58.8218Z",
    fill: "#D47858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9036 75.371C41.0572 74.9951 40.8803 74.5657 40.5085 74.4117C40.1367 74.2578 39.7107 74.4378 39.5571 74.8137C39.4035 75.1896 39.5803 75.6191 39.9522 75.773C40.324 75.9269 40.7499 75.7469 40.9036 75.371Z",
    fill: "#D47858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.243 78.3166C21.3861 77.9665 21.2201 77.5659 20.8721 77.4218C20.5242 77.2778 20.1261 77.4449 19.983 77.7951C19.8399 78.1452 20.0059 78.5458 20.3539 78.6899C20.7018 78.8339 21.0999 78.6668 21.243 78.3166Z",
    fill: "#D47858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6474 65.3149C43.1501 65.0528 43.3719 64.4796 43.1428 64.0347C42.9137 63.5898 42.3205 63.4416 41.8178 63.7037C41.3151 63.9659 41.0933 64.5391 41.3224 64.984C41.5515 65.4289 42.1447 65.5771 42.6474 65.3149Z",
    fill: "#D47858"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9203 74.3354C33.4229 74.0732 33.6447 73.5 33.4156 73.0551C33.1865 72.6102 32.5933 72.462 32.0906 72.7242C31.5879 72.9863 31.3661 73.5595 31.5952 74.0044C31.8243 74.4494 32.4176 74.5975 32.9203 74.3354Z",
    fill: "#D47858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.965 79.1086C32.3364 78.6399 32.3219 78.0067 31.9326 77.6942C31.5433 77.3818 30.9266 77.5084 30.5552 77.9771C30.1838 78.4458 30.1983 79.079 30.5876 79.3915C30.9769 79.7039 31.5936 79.5772 31.965 79.1086Z",
    fill: "#D47858"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 80.2192C28.4208 79.7227 28.3899 78.9743 27.9131 78.5476C27.4362 78.1209 26.694 78.1774 26.2553 78.674C25.8166 79.1705 25.8475 79.9189 26.3243 80.3456C26.8012 80.7723 27.5434 80.7158 27.9821 80.2192Z",
    fill: "#D47858"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 12,
    height: 78,
    rx: 3,
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassWithEggInVinegar);
export default __webpack_public_path__ + "static/media/glass_with_egg_in_vinegar.1ebed22b0c1505cd99d7137695a622f0.svg";
export { ForwardRef as ReactComponent };